import {ADD_MESSAGE, COLLAPSE_CHAT} from '../actions';

export default function unreadCount(state = 0, action) {
  switch (action.type) {
    case ADD_MESSAGE:
      return state + 1;
    case COLLAPSE_CHAT:
      return 0;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./chat-app/reducers/unreadCount.js